var Locations = (function($) {
  function openLocation($current, targetId, showMain) {
    var $container = $(".locations-blocks");
    var $menu = $(".locations-gallery-menu");
    var $blocks = $(".locations-block");
    var $others = $blocks.not($current);
    var $image = $current.find(".locations-block__image");
    var $target = $("#" + targetId);
    var $targetMain = $target.find(".locations-gallery-main");
    var originalLeft = $current.data("left") || $current.css("left");

    if (!$target.length) return;

    gsap.killTweensOf($container);
    gsap.killTweensOf($menu);
    gsap.killTweensOf($blocks);
    gsap.killTweensOf($blocks.find(".locations-block__image"));
    gsap.killTweensOf($(".locations-gallery"));
    gsap.killTweensOf($(".locations-gallery-main"));

    $(".locations-gallery")
      .removeClass("locations-gallery--active")
      .hide();

    $blocks.removeClass("is-expanded is-hidden");
    $current.addClass("is-expanded");

    gsap.set($container, {
      opacity: 1,
      display: "flex"
    });

    if (showMain) {
      gsap.set($container, {
        display: "none",
        opacity: 0,
        width: "100%",
        marginLeft: 0,
        marginRight: 0,
        overflow: "hidden"
      });
    } else {
      gsap.set($container, {
        display: "flex",
        opacity: 1,
        overflow: "visible"
      });
    }
    gsap.set($current, {
      left: originalLeft,
      width: "23.666%",
      opacity: 1,
      zIndex: 20
    });

    gsap.set($image, {
      clipPath: "inset(0 50% 0 50%)"
    });

    gsap.set($menu, {
      opacity: 0,
      pointerEvents: "auto"
    });

    $target.show().addClass("locations-gallery--active");
    var $targetMain = $target.find(".locations-gallery-main");

    if (showMain) {
      $targetMain.show();
      gsap.set($targetMain, {
        opacity: 0,
        y: 15
      });
    } else {
      $targetMain.hide();
    }

    gsap.set($target, {
      opacity: 0,
      y: 20
    });

    $(".locations-gallery-menu__link").removeClass(
      "locations-gallery-menu__link--current"
    );

    $('.locations-gallery-menu__link[data-link="' + targetId + '"]').addClass(
      "locations-gallery-menu__link--current"
    );

    var tl = gsap.timeline();

    tl.to(
      $container,
      {
        width: "calc(100% - 160px)",
        marginLeft: 80,
        marginRight: 80,
        duration: 0.85,
        ease: "expo.out"
      },
      0
    );

    tl.to(
      $others,
      {
        opacity: 0,
        duration: 0.45,
        ease: "power2.out",
        onComplete: function() {
          $others.addClass("is-hidden");
        }
      },
      0
    );

    tl.to(
      $current,
      {
        left: 0,
        width: "100%",
        duration: 0.85,
        ease: "expo.out"
      },
      0
    );

    tl.to(
      $image,
      {
        clipPath: "inset(0 0% 0 0%)",
        duration: 0.85,
        ease: "expo.out"
      },
      0
    );

    tl.to(
      $menu,
      {
        opacity: 1,
        duration: 0.35,
        ease: "power2.out"
      },
      0.35
    );

    tl.to(
      $target,
      {
        opacity: 1,
        y: 0,
        duration: 0.4,
        ease: "power2.out"
      },
      0.45
    );

    if (showMain) {
      tl.to(
        $targetMain,
        {
          opacity: 1,
          y: 0,
          duration: 0.35,
          ease: "power2.out"
        },
        0.55
      );
    }
  }

  function resetBlocks() {
    var $container = $(".locations-blocks");
    var $menu = $(".locations-gallery-menu");
    var $blocks = $(".locations-block");

    gsap.killTweensOf($container);
    gsap.killTweensOf($menu);
    gsap.killTweensOf($blocks);
    gsap.killTweensOf($blocks.find(".locations-block__image"));
    gsap.killTweensOf($(".locations-gallery-main"));

    gsap.set($container, {
      display: "flex"
    });

    gsap.to($menu, {
      opacity: 0,
      duration: 0.2,
      ease: "power2.out",
      onComplete: function() {
        gsap.set($menu, {
          pointerEvents: "none"
        });
      }
    });

    gsap.to($container, {
      opacity: 1,
      width: "100%",
      marginLeft: 0,
      marginRight: 0,
      duration: 0.55,
      ease: "power3.out"
    });

    $blocks.each(function() {
      var $block = $(this);
      var $image = $block.find(".locations-block__image");
      var originalLeft = $block.data("left") || $block.css("left");

      $block.removeClass("is-expanded is-hidden");

      gsap.set($image, {
        clearProps: "clipPath"
      });

      gsap.to($block, {
        left: originalLeft,
        width: "23.666%",
        opacity: 1,
        zIndex: 1,
        duration: 0.55,
        ease: "power3.out"
      });
    });
  }

  function updateLocationHash(targetId) {
    var hashMap = {
      "locations-gallery-spain": "#mainland-spain",
      "locations-gallery-balearic": "#balearic-islands",
      "locations-gallery-canary": "#canary-islands",
      "locations-gallery-portugal": "#portugal"
    };

    var newHash = hashMap[targetId];

    if (!newHash) return;

    history.replaceState(null, null, newHash);
  }

  function showGallery(targetId, showMain) {
    var $container = $(".locations-blocks");
    var $target = $("#" + targetId);

    if (!$target.length) return;

    var $currentActive = $(".locations-gallery--active");
    var $targetMain = $target.find(".locations-gallery-main");

    $(".locations-gallery-menu__link").removeClass(
      "locations-gallery-menu__link--current"
    );

    $('.locations-gallery-menu__link[data-link="' + targetId + '"]').addClass(
      "locations-gallery-menu__link--current"
    );

    // Si venimos del menú, ocultamos los blocks expandidos
    if (showMain) {
      gsap.to($container, {
        opacity: 0,
        duration: 0.3,
        ease: "power2.out",
        onComplete: function() {
          gsap.set($container, {
            display: "none",
            clearProps: "width,marginLeft,marginRight,opacity"
          });
        }
      });
    }

    // Si ya estamos en la misma galería
    if ($currentActive.length && $currentActive.is($target)) {
      if (showMain) {
        $targetMain.show();
        gsap.fromTo(
          $targetMain,
          { opacity: 0, y: 15 },
          { opacity: 1, y: 0, duration: 0.35, ease: "power2.out" }
        );
      } else {
        $targetMain.hide();
      }
      return;
    }

    gsap.to($currentActive, {
      opacity: 0,
      y: 20,
      duration: 0.3,
      ease: "power2.in",
      onComplete: function() {
        $currentActive.removeClass("locations-gallery--active").hide();

        $(".locations-gallery-main").hide();

        $target.show().addClass("locations-gallery--active");

        if (showMain) {
          $targetMain.show();
          gsap.set($targetMain, {
            opacity: 0,
            y: 15
          });
        } else {
          $targetMain.hide();
        }

        gsap.set($target, {
          opacity: 0,
          y: 20
        });

        gsap.to($target, {
          opacity: 1,
          y: 0,
          duration: 0.4,
          ease: "power2.out"
        });

        if (showMain) {
          gsap.to($targetMain, {
            opacity: 1,
            y: 0,
            duration: 0.35,
            ease: "power2.out",
            delay: 0.1
          });
        }
      }
    });
  }

  function closeGallery() {
    var $container = $(".locations-blocks");
    var $activeGallery = $(".locations-gallery--active");

    gsap.to($activeGallery, {
      opacity: 0,
      y: 20,
      duration: 0.4,
      ease: "power2.in",
      onComplete: function() {
        $activeGallery.removeClass("locations-gallery--active").hide();
        $(".locations-gallery-main").hide();

        $(".locations-gallery-menu__link").removeClass(
          "locations-gallery-menu__link--current"
        );

        $container.show();

        gsap.fromTo(
          $container,
          { opacity: 0 },
          {
            opacity: 1,
            duration: 0.35,
            ease: "power2.out",
            onComplete: function() {
              resetBlocks();
            }
          }
        );
      }
    });
  }

  function openLocationFromHash() {
    if (!$(".page-template-template-locations").length) return;

    var hash = window.location.hash;

    if (!hash) return;

    var locationsMap = {
      "#mainland-spain": {
        blockId: "locations-block-spain",
        targetId: "locations-gallery-spain"
      },
      "#balearic-islands": {
        blockId: "locations-block-balearic-islands",
        targetId: "locations-gallery-balearic"
      },
      "#canary-islands": {
        blockId: "locations-block-canary-islands",
        targetId: "locations-gallery-canary"
      },
      "#portugal": {
        blockId: "locations-block-portugal",
        targetId: "locations-gallery-portugal"
      }
    };

    var match = locationsMap[hash];

    if (!match) return;

    var $block = $("#" + match.blockId);

    if (!$block.length) return;

    openLocation($block, match.targetId, true);
    setTimeout(function() {
      scrollToLocationsIntro();
    }, 150);
  }

  function scrollToLocationsIntro() {
    var $intro = $(".locations-intro");

    if (!$intro.length) return;

    $intro[0].scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }

  function initLocations() {
    $(".locations-block__link").on("click", function(e) {
      e.preventDefault();

      var $block = $(this).parent();
      var targetId = $(this).data("link");
      updateLocationHash(targetId);

      openLocation($block, targetId, false);
    });

    $(".locations-gallery-menu__link").on("click", function(e) {
      e.preventDefault();

      var targetId = $(this).data("link");
      updateLocationHash(targetId); // 👈 aquí

      // Desde menú: ocultamos blocks y mostramos main
      showGallery(targetId, true);
    });

    $(".locations-gallery-close").on("click", function(e) {
      e.preventDefault();
      closeGallery();
    });

    $(".locations-back").on("click", function(e) {
      e.preventDefault();

      $(".locations-gallery")
        .removeClass("locations-gallery--active")
        .hide();

      $(".locations-gallery-main").hide();

      $container = $(".locations-blocks");
      $container.show();

      gsap.set($container, { opacity: 1 });

      resetBlocks();
    });
  }

  function init() {
    if (!$(".locations-blocks").length && !$(".locations-gallery").length) {
      return;
    }

    initLocations();
    openLocationFromHash();

    $(window).on("hashchange", function() {
      openLocationFromHash();
    });
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Locations.init);
